import React, { useCallback, useMemo, createElement, useState, useEffect } from 'react';

import ReactFlow, { 
  useNodesState, 
  useEdgesState, 
  addEdge, 
  ReactFlowProvider, 
  MiniMap,
  Controls,
  useStore,
} from 'reactflow';

import 'reactflow/dist/style.css';

import TimelineNode from './TimelineNode.js';
// import TimelineEdge from './TimelineEdge.js';

import * as XLSX from 'xlsx'; // Import the xlsx library to parse Excel files

// import $ from 'jquery';
import axios from "axios";
axios.defaults.xsrfCookieName = 'csrftoken'
axios.defaults.xsrfHeaderName = 'X-CSRFToken'
axios.defaults.withCredentials = true;







const highlightPathLegend = (arm_colors_db, arm_id, path, pathselected, color) => {

  document.querySelectorAll(path).forEach(path => {

    if (path.classList.contains(pathselected)) {

      path.classList.remove(pathselected);
      // uncheck checkbox
      document.getElementById("checkbox"+arm_id).checked = false;


      // if arm colors by another pathselected, revert to that color
      var hasPathSelected = false;
      var otherPathSelected = ''
      for (var c = 0; c < path.classList.length ; c ++){
        if (path.classList[c].startsWith('path-selected')) {
          hasPathSelected = true;
          otherPathSelected = path.classList[c];
        }
      }
      
      if (hasPathSelected){
        // get color of otherPathSelected
        var strokeColor = '#b1b1b7'
        arm_colors_db.map(color => {
          if (color.arm_id_normalized === otherPathSelected.split('path-selected-')[1]) {
            strokeColor = color.arm_color;
          }
        })

        path.style.stroke = strokeColor;
        path.style.strokeWidth = '5px';
        path.style.strokeDasharray = 'none !important';
      }

      else {
        // otherwise reverse to normal color
        path.style.stroke = '#b1b1b7';
        path.style.strokeWidth = '1px';
        path.style.strokeDasharray = '5px';
      }
    }

    else {

      path.classList.add(pathselected);
      // color path in arm color
      path.style.stroke = color;
      path.style.strokeWidth = '5px';
      path.style.strokeDasharray = 'none !important';

      // check checkbox
      document.getElementById("checkbox"+arm_id).checked = true;

    }

  });

}

const minimapStyle = {
  height: 120
};

// function to add clicked nodes to the compare list
const onCompareClick = (event, node, list, setlist, parentCallback) => {

  // if node in list, then remove
  if (list.filter(e => e === node.id).length > 0) { 
    list = list.filter(e => e !== node.id);
  }

  // else add node to list
  else {
    list.push(node.id);
  }

  // use setlist to change the state of compareNodesList
  // use setlist([...list]) instead of setlist(list), to specifically tell the component it is a new object and it needs to rerender
  setlist([...list]); 
  parentCallback([...list]);

}




// TIMELINE COMPONENT

const Timeline = (props) => {
  
  // to read and modify nodes position in excel
  const [parsedData, setParsedData] = useState(null); // State to store parsed data
  useEffect(() => {
    const readExcelFile = async () => {
      const reader = new FileReader();
      reader.onload = (event) => {
        const data = new Uint8Array(event.target.result);
        const workbook = XLSX.read(data, { type: 'array' });

        // Read specific sheets
        const plannedEventSheet = workbook.Sheets['planned_event'];
        const armSheet = workbook.Sheets['arm'];
        const arm2PlannedEventSheet = workbook.Sheets['arm_2_planned_event'];

        // Parse the data from the sheets into JSON format
        const plannedEventData = XLSX.utils.sheet_to_json(plannedEventSheet);
        const armData = XLSX.utils.sheet_to_json(armSheet);
        const arm2PlannedEventData = XLSX.utils.sheet_to_json(arm2PlannedEventSheet);

        // Store the parsed data in state
        setParsedData({
          plannedEvent: plannedEventData,
          arm: armData,
          arm2PlannedEvent: arm2PlannedEventData,
        });
      };
      reader.readAsArrayBuffer(props.excel_file); // Read the file
    };

    if (props.excel_file && props.excel_file != null) {
      readExcelFile();
    }
  }, [props.excel_file]);

  const excel_filename = useMemo(() => { 
    if (props.excel_filename && props.excel_file != ''){
      return props.excel_filename;
    }
    return ''
  }, [props.excel_filename]);
  
  // custom node and edge type for timeline
  const sdy = useMemo(() => {return props.study_id}, [props.study_id]);
  const arm_id = useMemo(() => {return props.arm_id}, [props.arm_id]);
  const nodes_db = useMemo(() => {return props.nodes}, [props.nodes]);
  const edges_db = useMemo(() => {return props.edges}, [props.edges]);
  const arm_colors_db = useMemo(() => {return props.arm_colors}, [props.arm_colors]);

  
  const [nodes, setNodes, onNodesChange] = useNodesState([]);
  const [edges, setEdges, onEdgesChange] = useEdgesState([]);
  const onConnect = useCallback((params) => setEdges((els) => addEdge(params, els)), []);
  const proOptions = { hideAttribution: true };
  
  const nodeTypes = useMemo(() => ({ TimelineNode: TimelineNode }), []); 
  // const edgeTypes = { TimelineEdge: TimelineEdge };

  // create compareNodesList
  const compare_nodes_list = useMemo(() => {return props.compare_nodes_list}, [props.compare_nodes_list]);
  const compare_nodes_callback = useMemo(() => {return props.compare_nodes_callback}, [props.compare_nodes_callback]);
  
  const [compareNodesList, setcompareNodesList] = useState(compare_nodes_list);


  // create nodes and edges
  const build_nodes_from_file = useCallback((arm_id) => {
    if (nodes!==undefined) {
      if (nodes.length < nodes_db.length){
        for (const n of nodes_db){

          if (arm_id){
            // Add arm_id dynamically to the node data
            const nodeWithArmId = {
              ...n,
              data: {
                ...n.data,
                arm_id, // Include arm_id
              },
            };

            setNodes((nds) => nds.concat(nodeWithArmId));  
          }

          else {
            setNodes((nds) => nds.concat(n));  
          }

        }  
      }
    }
  }, [setNodes, nodes_db, nodes]);


  const build_edges_from_file = useCallback(() => {
    if (nodes!==undefined) {
      if (edges.length < edges_db.length){
        for (const e of edges_db){
          setEdges((eds) => eds.concat(e));  
        }  
      }
    }
  }, [setEdges, edges_db, edges]);

  build_nodes_from_file(arm_id);
  build_edges_from_file();  



  // zoom features
  const isMaxZoom = useStore((store) => store.transform[2] === store.maxZoom);
  const isMinZoom = useStore((store) => store.transform[2] === store.minZoom);


  // const post_url = window.location.protocol + '//' + window.location.host + '/api_kb/receive_json_timeline/';
  const exportNodesPosition = () => {

    // var position_nodes = [];
    // const headers = ['planned_event_id', 'position_x', 'position_y'];
    // var converted_csv = '';

    if (parsedData){

      for (var n in nodes){

        var planned_event_to_change = parsedData.plannedEvent.filter(el => el.planned_event_id === nodes[n].id);
        planned_event_to_change[0].position_x = nodes[n].position.x;
        planned_event_to_change[0].position_y = nodes[n].position.y;

        // var node = {}
        // node['planned_event_id'] = nodes[n].id;
        // node['position_x'] = nodes[n].position.x;
        // node['position_y'] = nodes[n].position.y;
        // position_nodes.push(node);
      }

      // Create a new workbook
      const newtimeline = XLSX.utils.book_new();
      const filename = excel_filename + '.xlsx';

      // Convert the modified data back to worksheet format
      const plannedEventSheet = XLSX.utils.json_to_sheet(
        parsedData.plannedEvent,
        {'header': [
          'investigation_id', 'planned_event_id', 'event_type', 'event_subtype',
          'earliest_start', 'latest_start', 'end', 'time_unit', 'is_T0',
          'start_rule', 'end_rule', 'event_name', 'position_x', 'position_y'
        ]}
      );
      const armSheet = XLSX.utils.json_to_sheet(
        parsedData.arm,
        {'header': [
          'investigation_id', 'arm_id', 'arm_description', 'arm_name', 'hcc_arm_name'
        ]}
      );
      const arm2PlannedEventSheet = XLSX.utils.json_to_sheet(
        parsedData.arm2PlannedEvent,
        {'header': [
          'unique_id', 'arm_id', 'planned_event_id', 'order'
        ]}
      );

      // Append sheets to the workbook
      XLSX.utils.book_append_sheet(newtimeline, plannedEventSheet, 'planned_event');
      XLSX.utils.book_append_sheet(newtimeline, armSheet, 'arm');
      XLSX.utils.book_append_sheet(newtimeline, arm2PlannedEventSheet, 'arm_2_planned_event');

      // Trigger the download
      XLSX.writeFile(newtimeline, filename);
    }
  }

  
  return (

    <div id={props.id} className={props.display ? "TimeLine timeline-displayed" : "TimeLine"}>

      {props.arm_id != '' ? 
        <a className='timeline-arm-title' href={"/query/results/?arms_id="+ props.arm_id +"&ordering_tab=arms_tab"}>
          {props.arm_id} - {props.arm_description}
        </a>

        : ''
      }

      <ReactFlow
        nodeTypes={nodeTypes}
        // edgeTypes={edgeTypes}
        nodes={nodes}
        edges={edges}
        onNodeClick={(event, node) => onCompareClick(event, node, compareNodesList, setcompareNodesList, compare_nodes_callback)}
        onNodesChange={onNodesChange}
        onEdgesChange={onEdgesChange}
        onConnect={onConnect}
        fitView
        proOptions={proOptions}
        panOnScroll={true}
        attributionPosition="top-right"
      >

        <MiniMap style={minimapStyle} zoomable pannable />
        <Controls
          className={[
            isMaxZoom ? "zoom-in-disabled" : "",
            isMinZoom ? "zoom-out-disabled" : ""
          ].join(" ")}
        />

      </ReactFlow>


      <div className="flowchart-legend">

        { (arm_colors_db !== undefined && arm_colors_db.length > 0) ? 

          arm_colors_db.map(color => (
        
            <div id={"legend-"+color.arm_id_normalized} className="legend-tile" onClick={() => { highlightPathLegend(arm_colors_db, color.arm_id_normalized, '.color-'+color.arm_id_normalized+' path', 'path-selected-'+color.arm_id_normalized, color.arm_color) }}>
              <div className="rect" style={{ background: color.arm_color }}></div>
              <p>{color.arm_id}</p>
            </div>

          ))  
        
          : 
          
          ''
        
        }

        <div id="legend-t0" className="legend-tile">
          <div className="circle"></div>
          <p>t0</p>
        </div>

      </div>
      
      { props.export ?  
        <div className="export-nodes" onClick={exportNodesPosition}>
          <p>Export file</p>
        </div>
        :
        ''
      }
    
    </div>

  );
};


// wrapping with ReactFlowProvider is done outside of the component
function FlowWithProvider(props) {
  return (
    <ReactFlowProvider>
      <Timeline {...props} />
    </ReactFlowProvider>
  );
}


export default FlowWithProvider;
// export default Timeline;

